import React from 'react';
import ReactDOM from 'react-dom';
import Tbm from './Tbm.js';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <Tbm />,
  document.getElementById('root')
);

serviceWorker.unregister();
